module.exports = __webpack_public_path__ + "img/yinghe.7a73e70d.jpg";